import React, { useState, useEffect } from 'react';
import Confetti from 'react-confetti';
import { Download } from 'lucide-react';

const Finish = ({ mergedVideoPath, currentStep }) => {
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (mergedVideoPath && currentStep === 6) {
      setShowConfetti(true);
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [mergedVideoPath, currentStep]);

  return (
    <div className="p-4 relative">
      {showConfetti && <Confetti />}
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-white p-4 rounded-lg mb-4 text-center bg-gradient-to-r from-purple-500 to-pink-500">Your Video is Ready!</h2>
        <div className="aspect-w-16 aspect-h-9 rounded-2xl overflow-hidden">
          {mergedVideoPath ? (
            <video controls autoPlay loop muted src={mergedVideoPath} className="w-full h-full object-cover">
            </video>
          ) : (
            <div className="w-full h-full bg-gray-200 flex items-center justify-center">
              <p>No video to display.</p>
            </div>
          )}
        </div>
        {mergedVideoPath && (
          <div className="text-center mt-4">
            <a
              href={mergedVideoPath}
              download
              className="inline-flex items-center bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors"
            >
              <Download className="w-4 h-4 mr-2" />
              Download Video
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Finish;
